<div class="modal-body">
  <div class="confirmacao-container">
    <div class="icone-confirmacao">
      <i class="fa {{ getIcone() }}"></i>
    </div>

    <h4 class="titulo-confirmacao" *ngIf="titulo">{{ titulo }}</h4>

    <div class="mensagem-confirmacao" [innerHTML]="mensagem">
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="cancelar()">
    {{ textoCancelamento }}
  </button>

  <button
    type="button"
    class="btn {{ getClasseBotao() }}"
    (click)="confirmar()">
    {{ textoConfirmacao }}
  </button>
</div>
